export default "__VITE_ASSET__BYyseXCi__"